module.exports = __webpack_public_path__ + "img/macarenaperez.7185a1b9.jpg";